import { render, staticRenderFns } from "./fpgl.vue?vue&type=template&id=8e2f09a8&scoped=true&"
import script from "./fpgl.vue?vue&type=script&lang=js&"
export * from "./fpgl.vue?vue&type=script&lang=js&"
import style0 from "./fpgl.vue?vue&type=style&index=0&id=8e2f09a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2f09a8",
  null
  
)

export default component.exports